export default (that = {}) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.type === 'checkbox'
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: that.type === 'radio'
  },
  {
    title: that.$l('INDEX.order_package_materialNo') || '物料编号',
    field: 'materialNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_package_materialName') || '包装名称',
    field: 'materialName',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'showName'
    }
  },
  {
    title: that.$l('INDEX.order_package_materialSize') || '包装尺寸',
    field: 'materialSpec',
    minWidth: 160,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_package_boxWeight') || '包装箱重量(g)',
    field: 'boxWeight',
    width: 80,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_package_isSpecify') || '指定供应商',
    field: 'v_isSpecify',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.order_package_scmName') || '供应商',
    field: 'scmName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  }
]
